export default function FooterAddress() {
  return (
    <div className="global-footer__address">
      <address>
        The Sole Supplier
        <br />
        3rd Floor
        <br />
        86-90 Paul Street
        <br />
        London EC2A 4NE
        <br />
      </address>
    </div>
  );
}
